import { createStore } from "vuex";
import data from "@/storedata.json";
import authModule from "./modules/userSlice";

export default createStore({
  modules: {
    auth: authModule,
  },
  state: {
    storedata: data,
    cart: [],
    cartUIStatus: "idle",
  },
  getters: {
    bestSellerProducts: (state) => state.storedata.slice(0, 4),
    furniture: (state) =>
      state.storedata.filter((el) => el.category === "Furniture"),
    lighting: (state) =>
      state.storedata.filter((el) => el.category === "Lighting"),
    rug: (state) => state.storedata.filter((el) => el.category === "Rug"),
    cartCount: (state) => {
      if (!state.cart.length) return 0;
      return state.cart.reduce((ac, next) => ac + next.quantity, 0);
    },
    cartItems: (state) => {
      if (!state.cart.length) return [];
      return state.cart.map((item) => {
        return {
          id: item.id,
          name: item.name,
          price: item.price,
          quantity: item.quantity,
        };
      });
    },
    cartTotal: (state) => {
      if (!state.cart.length) return 0;
      return state.cart.reduce(
        (ac, next) => ac + next.quantity * next.price,
        0
      );
    },
  },
  mutations: {
    updateCartUI(state, payload) {
      state.cartUIStatus = payload;
    },
    clearCart(state) {
      (state.cart = []), (state.cartUIStatus = "idle");
    },
    addToCart(state, payload) {
      let itemfound = state.cart.find((el) => el.id === payload.id);
      itemfound
        ? (itemfound.quantity += payload.quantity)
        : state.cart.push(payload);
    },
    addOneToCart(state, payload) {
      let itemfound = state.cart.find((el) => el.id === payload.id);
      itemfound ? itemfound.quantity++ : state.cart.push(payload);
    },
    removeOneFromCart(state, payload) {
      let itemfound = state.cart.find((el) => el.id === payload.id);
      itemfound.quantity > 1
        ? itemfound.quantity--
        : state.cart.splice(state.cart.indexOf(itemfound), 1);
    },
    removeAllFromCart(state, payload) {
      state.cart = state.cart.filter((el) => el.id !== payload.id);
    },
    checkOut(state) {
      state.cart = [];
    },
  },
});
